
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ServiceForm } from "@/components/professional/ServiceForm";
import { ServiceList } from "@/components/professional/ServiceList";
import { supabase } from "@/integrations/supabase/client";

const ProfessionalServices = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const { data: services, isLoading } = useQuery({
    queryKey: ["professional-services"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase
        .from("professional_services")
        .select("*")
        .eq("professional_id", user.id)
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data;
    },
  });

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Services et produits</h1>
          <p className="text-muted-foreground mt-2">
            Gérez les services et produits que vous proposez à vos patients
          </p>
        </div>
        <Button onClick={() => setIsFormOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          Ajouter un service
        </Button>
      </div>

      <ServiceForm 
        open={isFormOpen}
        onOpenChange={setIsFormOpen}
      />

      <ServiceList 
        services={services || []}
        isLoading={isLoading}
      />
    </div>
  );
};

export default ProfessionalServices;
